const CONFIG = {
  CRS_CONSUMER_CONSENT_SERVICE: 'http://localhost:8080',
};

export default CONFIG;
